import React, {
    useCallback, useEffect
} from 'react';
import _ from 'lodash';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import { useUpdateSubmissionServices, validationUtil } from 'premier-capability-hooks';
import { PremierConstants } from 'premier-constant-service';

import { AdditionalInterestComponent } from "premier-capability-policyjob-react";
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import metadata from './LiabilityCoveragesPage.metadata.json5';
import messages from './LiabilityCoveragesPage.messages.js';
import styles from '../Commercial/CommercialPage.module.scss';

import CoveragesPageComponent from "../Coverages/CoveragesPage";
import AddlInterestTextBoxComponent from "../../components/AddlInterestTextBoxComponent/AddlInterestTextBoxComponent";

function LiabilityCoveragesPage(props) {

    const { wizardData: submissionVM, updateWizardData } = props;

    const { lineName } = PremierConstants;
    const { updateSubmission } = useUpdateSubmissionServices();

    const {
        onValidate,
        initialValidation
    } = useValidation('LiabilityCoveragesPage');

    const onNext = useCallback(
        async () => {

            const { productCode } = submissionVM.value.baseData;
            const lobLineName = lineName[productCode];

            submissionVM.value = await updateSubmission(lobLineName, 'PropertyCoveragesPage', submissionVM);

            return submissionVM;
        },
        [lineName, submissionVM, updateSubmission]
    );

    const onSave = useCallback(
        async () => {
            const subVMCopy = _.clone(submissionVM)
            const productCode = _.get(subVMCopy.value, 'baseData.productCode');

            validationUtil.unSetIsValidationReqFlag(subVMCopy.lobData.cybLiaLine.coverables.additionalInterests.value, ' ')

            const lobLineName = productCode ? lineName[productCode] : '';
            await updateSubmission(lobLineName, 'LiabilityCoveragesPage', subVMCopy);
                            
            return submissionVM;
        },
        [lineName, submissionVM, updateSubmission]
    );

    useEffect(() => {

    }, []);

    const overrideProps = {
        pclLineCoverageComponent: {
            wizardData: submissionVM,
            updateWizardData,
            clausesBasePath: `lobData.cybLiaLine.lineCoverages.coverages`,
            title: messages.covMiscellaneous,
            clasueType: 'coverages',
            pathToGet: 'cybLiaLine.coverages'
        },
        additionalInterest: {
            wizardData: submissionVM,
            updateWizardData,
            addlIntPath: 'lobData.cybLiaLine.coverables.additionalInterests',
            selectedOffering: _.get(submissionVM, 'lobData.value.cybLiaLine.selectedOffering_Ext')
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            coveragespagecomponent: CoveragesPageComponent,
            additionalInterestComponent: AdditionalInterestComponent,
            AddlInterestTextBoxComponent
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.pageContent, submissionVM, id, path, overrideProps),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [metadata, submissionVM, overrideProps]
    );


    const isDisableNext = () => _.find(submissionVM.value.lobData.cybLiaLine.lineCoverages.coverages, { isValid: false })
        || !_.get(submissionVM, 'lobData.cybLiaLine.coverables.additionalInterests.aspects.subtreeValid')

    return (
        <WizardPage onNext={onNext} onSave={onSave} skipWhen={initialValidation} disableNext={isDisableNext()}>
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                onModelChange={updateWizardData}
                overrideProps={overrideProps}
                onValidationChange={onValidate}
                resolveValue={readValue}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
            />
        </WizardPage>
    );
}

LiabilityCoveragesPage.propTypes = wizardProps;
export default withRouter(LiabilityCoveragesPage);
